import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import {
  DocumentPublicationsIcon,
  DocumentTemplatesIcon,
} from "@icarius-icons/";
import { getLocalizedString } from "@icarius-localization/strings";

const Index = () => {

  const data = [
    {
      name: getLocalizedString("documentTemplates"),
      icon: <DocumentTemplatesIcon />,
      path: paths.documentTemplates,
    },
    {
      name: getLocalizedString("documentPublications"),
      icon: <DocumentPublicationsIcon />,
      path: paths.documentPublication,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("documents")}
      data={data}
    />
  );
}

export default Index;